import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, FilePlus, FileText, Settings, LogOut } from 'lucide-react';
export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () => { logout(); navigate('/login'); };
  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';
  return (
    <nav className="navbar">
      <div className="navbar-brand"><span></span><span></span></div>
      <div className="navbar-menu">
        <button className={isActive('/')} onClick={() => navigate('/')}><LayoutDashboard size={16}/><span>대시보드</span></button>
        <button className={isActive('/new')} onClick={() => navigate('/new')}><FilePlus size={16}/><span>결재작성</span></button>
        <button className={isActive('/list')} onClick={() => navigate('/list')}><FileText size={16}/><span>결재목록</span></button>
        <button className={isActive('/leave')} onClick={() => navigate('/leave')}><span style={{fontSize:16}}>🏖️</span><span>휴가신청</span></button>
        {user?.role === 'admin' && <button className={isActive('/admin')} onClick={() => navigate('/admin')}><Settings size={16}/><span>관리자</span></button>}
      </div>
      <div className="nav-user">
        <div className="avatar">{user?.name?.[0]}</div>
        <span style={{fontSize:14,color:'#374151'}}>{user?.name}  {user?.position}</span>
        <button className="btn btn-secondary btn-sm" onClick={handleLogout}><LogOut size={14}/> </button>
      </div>
    </nav>
  );
}